module.exports = __webpack_public_path__ + "img/transitions.998a1b20.jpg";